// Plantilla que el negocio copia en Google Apps Script. Vive fuera del
// componente para que el archivo de la página solo exporte el componente.
export const GOOGLE_APPS_SCRIPT_TEMPLATE = `// -------------------------------------------------------------
// IridiaChat - Webhook para Google Sheets (Descuento y Devolución)
// -------------------------------------------------------------

function doGet(e) {
  return ContentService.createTextOutput(JSON.stringify({
    status: "online",
    message: "Google Apps Script de IridiaChat activo y listo para recibir webhooks.",
    timestamp: new Date().toISOString()
  })).setMimeType(ContentService.MimeType.JSON);
}

function doPost(e) {
  try {
    if (!e || !e.postData || !e.postData.contents) {
      return ContentService.createTextOutput(JSON.stringify({
        success: false,
        error: "No se recibieron datos en el cuerpo de la petición"
      })).setMimeType(ContentService.MimeType.JSON);
    }

    var data = JSON.parse(e.postData.contents);
    var isSale = data.event === 'sale_completed' || data.event === 'inventory.sale_completed';
    var isCancel = data.event === 'order_cancelled' || data.event === 'inventory.order_cancelled';
    var isProductUpdate = data.event === 'product_updated' || data.event === 'stock_updated' || data.event === 'inventory.product_updated';

    // Ping de verificación de conexión en vivo
    if (data.event === 'test_ping' || data.event === 'inventory.test_ping') {
      return ContentService.createTextOutput(JSON.stringify({
        success: true,
        message: "Ping recibido correctamente en Google Sheets",
        timestamp: new Date().toISOString()
      })).setMimeType(ContentService.MimeType.JSON);
    }

    // Lista de ítems a procesar (acepta array data.items o data.product)
    var updateItems = Array.isArray(data.items) ? data.items : (data.product ? [data.product] : []);

    // Procesamiento de venta, cancelación o edición directa de producto/stock
    if ((isSale || isCancel || isProductUpdate) && updateItems.length > 0) {
      var sheet = SpreadsheetApp.getActiveSpreadsheet().getActiveSheet();
      var rows = sheet.getDataRange().getValues();
      if (!rows || rows.length === 0) {
        return ContentService.createTextOutput(JSON.stringify({
          success: false,
          error: "La hoja de cálculo no contiene datos"
        })).setMimeType(ContentService.MimeType.JSON);
      }

      var headers = rows[0].map(function(h) { return String(h).trim().toLowerCase(); });
      var skuIdx = headers.indexOf('sku');
      var stockIdx = headers.findIndex(function(h) {
        return h.includes('stock') || h.includes('cant') || h.includes('existenc');
      });
      var priceIdx = headers.findIndex(function(h) {
        return h.includes('precio') || h.includes('price');
      });

      if (skuIdx === -1) {
        return ContentService.createTextOutput(JSON.stringify({
          success: false,
          error: "No se encontró la columna 'SKU' en la fila 1 de la hoja"
        })).setMimeType(ContentService.MimeType.JSON);
      }

      var updatedCount = 0;
      updateItems.forEach(function(item) {
        var itemSku = String(item.sku).trim().toLowerCase();
        for (var i = 1; i < rows.length; i++) {
          if (String(rows[i][skuIdx]).trim().toLowerCase() === itemSku) {
            if (stockIdx !== -1) {
              if (isProductUpdate) {
                // Actualización directa desde el panel de productos de IridiaChat (valor absoluto)
                var newStock = item.stock !== undefined ? Number(item.stock) : (Number(item.quantity) || 0);
                sheet.getRange(i + 1, stockIdx + 1).setValue(newStock);
              } else {
                // Venta en WhatsApp descuenta; Cancelación devuelve
                var currentStock = Number(rows[i][stockIdx]) || 0;
                var qty = Number(item.quantity) || 1;
                var newStock = isSale ? Math.max(0, currentStock - qty) : (currentStock + qty);
                sheet.getRange(i + 1, stockIdx + 1).setValue(newStock);
              }
            }

            // Si se envió precio y la hoja tiene columna de precio, actualizarla
            if (isProductUpdate && priceIdx !== -1 && (item.price !== undefined || item.priceCents !== undefined)) {
              var priceVal = item.price !== undefined ? Number(item.price) : (Number(item.priceCents) / 100);
              sheet.getRange(i + 1, priceIdx + 1).setValue(priceVal);
            }

            updatedCount++;
            break;
          }
        }
      });

      return ContentService.createTextOutput(JSON.stringify({
        success: true,
        updatedItems: updatedCount,
        message: isProductUpdate
          ? "Producto y stock actualizados en hoja con éxito (" + updatedCount + " filas actualizadas)"
          : isSale
          ? "Stock descontado con éxito (" + updatedCount + " productos actualizados)"
          : "Stock devuelto por cancelación con éxito (" + updatedCount + " productos actualizados)"
      })).setMimeType(ContentService.MimeType.JSON);
    }

    return ContentService.createTextOutput(JSON.stringify({
      success: false,
      error: "Evento no soportado o sin lista de items"
    })).setMimeType(ContentService.MimeType.JSON);

  } catch (err) {
    return ContentService.createTextOutput(JSON.stringify({
      success: false,
      error: err.message
    })).setMimeType(ContentService.MimeType.JSON);
  }
}

// Ejecuta esta función una única vez desde el editor para autorizar permisos a tu hoja
function autorizarPermisos() {
  SpreadsheetApp.getActiveSpreadsheet().getActiveSheet().getName();
  Logger.log("Permisos autorizados correctamente en tu hoja.");
}
`
